import React from "react";
import { Stack, Tooltip, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { DataGridRowActionsMenu, type RowActionItem } from "./DataGridRowActionsMenu.js";

// Azioni di riga con TASTI RAPIDI (icone) per le azioni più usate + menu ⋮ COMPLETO.
// Si passa l'elenco completo `items` (gli stessi RowActionItem del menu) e le `quickKeys`
// da promuovere a icona (nell'ordine indicato). Il menu ⋮ continua a mostrare TUTTE le
// azioni: le icone sono scorciatoie aggiuntive, non sostituiscono le voci del menu.
export function RowQuickActions({
  items,
  quickKeys,
  ariaLabel
}: {
  items: RowActionItem[];
  quickKeys: string[];
  ariaLabel?: string;
}) {
  const quick = quickKeys
    .map((k) => items.find((i) => i.key === k))
    .filter(Boolean) as RowActionItem[];
  // Il menu ⋮ mostra SEMPRE tutte le azioni: i tasti rapidi sono in aggiunta,
  // non sostituiscono le voci del menu.
  const menu = items;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="flex-end" sx={{ width: "100%" }}>
      {quick.map((a) => (
        <Tooltip
          key={a.key}
          title={a.description || a.label}
          arrow
          placement="top"
          enterTouchDelay={0}
          slotProps={{
            tooltip: {
              sx: {
                // Tooltip grande e leggibile (pensato per chi non ha più una vista perfetta):
                // testo 16px in grassetto, alto contrasto, padding ampio.
                fontSize: "1rem",
                fontWeight: 600,
                lineHeight: 1.45,
                py: 1.1,
                px: 1.8,
                maxWidth: 340,
                letterSpacing: "0.01em",
                bgcolor: "rgba(15,31,20,0.98)",
                color: "#fff",
                borderRadius: 1.5,
                boxShadow: 6,
                "& .MuiTooltip-arrow": { color: "rgba(15,31,20,0.98)" }
              }
            }
          }}
        >
          <span>
            <IconButton
              disabled={a.disabled}
              aria-label={a.label}
              onClick={(e) => { e.stopPropagation(); a.onClick(); }}
              sx={(theme) => {
                // Riquadro arrotondato con bordo leggero; colore semantico
                // (verde brand per le azioni, rosso per quelle distruttive).
                const tone = a.destructive ? theme.palette.error.main : theme.palette.primary.main;
                return {
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: alpha(tone, 0.28),
                  color: tone,
                  // Più visibile in ALTEZZA (non in larghezza): padding verticale maggiore.
                  padding: "10px 6px",
                  transition: theme.transitions.create(["background-color", "border-color"], { duration: 120 }),
                  "& svg": { fontSize: 22 },
                  "&:hover": {
                    backgroundColor: alpha(tone, 0.12),
                    borderColor: alpha(tone, 0.6)
                  },
                  "&.Mui-disabled": {
                    borderColor: alpha(theme.palette.action.disabled, 0.24),
                    color: theme.palette.action.disabled
                  }
                };
              }}
            >
              {a.icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
      {menu.length > 0 && <DataGridRowActionsMenu items={menu} ariaLabel={ariaLabel} />}
    </Stack>
  );
}
